// themes/default.ts
import { createTheme } from '@mui/material/styles';

export const fontStack = `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
  "Helvetica Neue", Arial, "Noto Sans", sans-serif,
  "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`;

const theme = createTheme({
    typography: {
        fontFamily: fontStack,
        root: {
            fontFamily: fontStack,
        },
    },
    MuiTypography: {
        styleOverrides: {
            root: {
                fontFamily: fontStack,
            },
        },
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontFamily: fontStack,
                },
                root: {
                    fontFamily: fontStack,
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    fontFamily: fontStack,
                },
                root: {
                    fontFamily: fontStack,
                },
            },
        },

        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: fontStack,
                },
            },
        },

    },
});

export default theme;
